module.exports = __webpack_public_path__ + "static/img/3-1.c32743c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/3-1.png
// module id = M9Oj
// module chunks = 1